var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white text-center px-4 py-2 bg-cv-green text-xs"},[_vm._v(" © 2020. Cruz Verde. Todos los derechos reservados. ")])}
var staticRenderFns = []

export { render, staticRenderFns }